import { render, staticRenderFns } from "./InspirationsFormPage.vue?vue&type=template&id=379e48c6&scoped=true&"
import script from "./InspirationsFormPage.vue?vue&type=script&lang=js&"
export * from "./InspirationsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./InspirationsFormPage.vue?vue&type=style&index=0&id=379e48c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379e48c6",
  null
  
)

export default component.exports